'use client';

import React from 'react';
import Link from 'next/link';
import { useLanguage } from '@/context/LanguageContext';

/**
 * Recuadro dorado de la portada: el servicio de importador de registro tiene que
 * verse a primera vista (pedido de José, 9-oct-2026). Sin «NEW / NUEVO»: lo que
 * lo destaca es el recuadro. Lleva a la sección completa en /services.
 */

const GOLD = '#C9A84C';
const GOLD_TEXT = '#E3C878';

export default function ExporterServiceBanner() {
  const { t } = useLanguage();

  return (
    <section className="relative z-10 bg-brand-bg pb-10">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div
          className="rounded-2xl p-6 md:p-8 flex flex-col md:flex-row md:items-center justify-between gap-6"
          style={{
            background: 'linear-gradient(135deg, #0d1a27 0%, #152b40 55%, #10333f 100%)',
            border: `2px solid ${GOLD}`,
            boxShadow: '0 0 0 4px rgba(201,168,76,0.18), 0 16px 40px rgba(11,44,74,0.18)',
          }}
        >
          <div className="flex items-start gap-4">
            <div
              className="w-12 h-12 rounded-xl flex items-center justify-center shrink-0"
              style={{ background: 'rgba(201,168,76,0.14)', border: `1.5px solid ${GOLD}` }}
            >
              <svg width="22" height="22" fill="none" stroke={GOLD_TEXT} strokeWidth="1.6" viewBox="0 0 24 24">
                <path d="M12 2l8 3v6c0 5-3.4 9.4-8 11-4.6-1.6-8-6-8-11V5z" />
                <path d="M8.5 12l2.5 2.5 4.5-5" />
              </svg>
            </div>
            <div>
              <span className="block text-xs font-bold uppercase tracking-[0.18em] mb-1.5" style={{ color: GOLD_TEXT }}>
                {t('xsvc.label')}
              </span>
              <div className="font-display text-white font-bold text-xl md:text-2xl leading-snug" style={{ letterSpacing: '-0.015em' }}>
                {t('xsvc.title')}
              </div>
              <p className="text-sm md:text-[15px] leading-relaxed mt-2 max-w-2xl m-0" style={{ color: 'rgba(255,255,255,0.72)' }}>
                {t('xsvc.banner.lead')}
              </p>
            </div>
          </div>

          <Link
            href="/services#importador-de-registro"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 rounded-full font-semibold text-sm whitespace-nowrap self-start md:self-center transition-all duration-300 hover:-translate-y-0.5"
            style={{ background: GOLD, color: '#241c05' }}
          >
            {t('xsvc.banner.cta')}
            <svg width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path d="M5 12h14M12 5l7 7-7 7" /></svg>
          </Link>
        </div>
      </div>
    </section>
  );
}
